import { GetStaticPaths, GetStaticProps } from 'next';
import Container from '~/components/common/container';
import { getLanguagesPaths } from '~/utils/translate';
import FunSection from '~/components/about-page/fun-section';
import AppSection from '~/components/about-page/app-section';
import BoldSaudi from '~/components/about-page/bold-saudi';
import OurAwards from '~/components/about-page/our-awards';
import Vision from '~/components/about-page/vision';
import Vision2030 from '~/components/about-page/vision-2030';
import AboutTop from '~/components/about-page/top-section';
import AboutHeader from '~/components/about-page/about-header';
import { Translate, useTranslate } from '~/i18n';
import { NextSeo } from 'next-seo';

const AboutPage = () => {
   const { translate } = useTranslate();

   return (
      <div>
         <NextSeo title={translate({ id: 'common:about' })} />
         <Container className="mt-16 py-7 tablet:mt-0">
            <div className="flex">
               <AboutHeader />
               <AboutTop
                  share_title={<Translate id="about:your super app" />}
                  share_description={<Translate id="about:discover things around you" />}
               />
            </div>
            <FunSection />
         </Container>
         <AppSection />
         <BoldSaudi />
         <Vision />
         <Vision2030 />
         <OurAwards />

         <style jsx global>{`
            body #__next main {
               background-color: white;
            }
         `}</style>
      </div>
   );
};
export const getStaticPaths: GetStaticPaths = async () => {
   return {
      paths: getLanguagesPaths(),
      fallback: false,
   };
};

/******************************************************************
 *
 *  THIS PAGE IS USING STATIC SITE GENERATION
 *
 ******************************************************************/

export const getStaticProps: GetStaticProps = async () => {
   return {
      props: {},
   };
};
export default AboutPage;
